(function () {
    "use strict";

    angular.module("app").component("dopSelection", {
        templateUrl: "@/dossiers/dop-selection.html",
        bindings: {
            readonly: "=",
            selection: "<",
            onSelectionChanged: "=",
            getDisplayValue: "=",
            disabled: "=",
        },
        controller: DossierOrganisationPersonSelection
    });

    DossierOrganisationPersonSelection.$inject = [
        "$scope", "$attrs",
        "controllerDecorator", "infiniteScrollDataSourceFactory", "dossierService",
    ];
    function DossierOrganisationPersonSelection(
        $scope, $attrs,
        controllerDecorator, infiniteScrollDataSourceFactory, dossierService,
    ) {
        const $ctrl = this;

        controllerDecorator.Decorate($ctrl, ["dialog"]);

        $ctrl.openSearchModal = openSearchModal;
        $ctrl.removeItem = removeItem;
        $ctrl.disabled = $ctrl.disabled === "true" || ($attrs.hasOwnProperty("disabled") && $attrs.disabled === undefined);

        $ctrl.$onChanges = (changes) => {
            if (changes.selection) {
                $ctrl.activeSelection = angular.copy($ctrl.selection);
            }
        };

        // TODO: Use dopSearchService
        function openSearchModal() {
            $ctrl.activeSelection = angular.copy($ctrl.selection);

            const scope = Object.assign($scope, prepareSearchViewModel());

            $ctrl.Dialog.Custom({
                templateUrl: "@/dossiers/dop-search.html",
                scope,
                title: $ctrl.getTranslation("Select_Person_s"),
                size: "large",
                onEscape: true,
                closeButton: true,
                buttons: {
                    submit: {
                        label: $ctrl.getTranslation("Button_Confirm"),
                        className: "btn-primary",
                        callback: () => {
                            $ctrl.onSelectionChanged($ctrl.activeSelection);
                        },
                    },
                    cancel: {
                        label: $ctrl.getTranslation("Button_Cancel"),
                        className: "btn-default"
                    },
                },
            });

            function prepareSearchViewModel() {
                const vm = {
                    isLoadingRequests: false,
                    handleCheckboxClick,
                    isItemSelected,
                };

                vm.DataSource = infiniteScrollDataSourceFactory.CreateChild(modifyFilterAndSearch, (v) => vm.isLoadingRequests = v);

                const pageAndSort = vm.DataSource.GetPageAndSort();

                if (!pageAndSort.SortBy.length) {
                    pageAndSort.SortBy.push({ Name: "DossierPerson.Name", IsReverse: false });
                }

                vm.sortType = pageAndSort.SortBy[0].Name;
                vm.sortReverse = pageAndSort.SortBy[0].IsReverse;

                const filter = vm.DataSource.GetFilter();

                filter.RequireRequest = true;

                return vm;

                function modifyFilterAndSearch(payload, successCallback, errorCallback, finallyCallback) {
                    dossierService.searchOrganisationPersonPaged(payload, successCallback, errorCallback, finallyCallback);
                }

                function handleCheckboxClick($event, item) {
                    if ($event.target.checked) {
                        $ctrl.activeSelection.push(
                            {
                                FullName: item.DossierPerson.Name,
                                ReferenceNbr: item.DossierPerson.ReferenceNbr,
                                DossierNbr: item.DossierPerson.DossierNbr,
                                DossierOrganisationPersonPublicId: item.PublicId,
                            });
                    } else {
                        let itemIndex = findSelectedItemIndex(item);

                        while (itemIndex >= 0) {
                            $ctrl.activeSelection.splice(itemIndex, 1);
                            itemIndex = findSelectedItemIndex(item);
                        }
                    }
                }

                function isItemSelected(item) {
                    return findSelectedItemIndex(item) >= 0;
                }

                function findSelectedItemIndex(item) {
                    return $ctrl.activeSelection.findIndex(selectedItem => selectedItem.ReferenceNbr === item.DossierPerson?.ReferenceNbr);
                }

            }
        }

        function removeItem(index, bubbleUp) {
            $ctrl.activeSelection.splice(index, 1);

            if (bubbleUp) {
                $ctrl.onSelectionChanged($ctrl.activeSelection);
            }
        }
    }
})();